
















import Vue from 'vue';
export default Vue.extend({
  props: ['headerList', 'gridTemplateColumns'],
  mounted() {
    const slotList = (this.$refs.rowTable as HTMLElement).querySelectorAll(
      '.table__data',
    );
    const tableBorderDiv = `<div class="table__border" />`;

    slotList.forEach((el, idx) => {
      if ((idx + 1) % this.headerList.length === 0) {
        slotList[idx].insertAdjacentHTML('afterend', tableBorderDiv);
      }
    });
  },
});
